import { doc, updateDoc } from 'firebase/firestore';
import { userAsPromise } from '../../providers/userProvider';
import { IOrganizationOptions } from '../../types';

/**
 * @description persists the organization options
 * @param options
 */
export const saveOrgOptions = async (
  options: IOrganizationOptions
): Promise<void> => {
  const user = await userAsPromise();

  return updateDoc(doc(user.services.firestore, `orgs/${user.orgId}`), {
    options,
  });
};
